<div class="user-shell">
  <app-logged-in-header
    [backgroundColor]="'#00637C'"
    [dark]="true"
    [showBrand]="true"
    brandLogoSrc="assets/svgs/logo-white.svg"
  ></app-logged-in-header>

		  <div class="user-shell__body">
		    <div class="user-shell__container">
		      	<div class="user-shell__nav" *ngIf="!hideTopTabs">
		        <!-- <div class="user-tabs">
					<a
						class="user-tab"
						routerLink="/user/vendors"
					routerLinkActive="user-tab--active"
					[routerLinkActiveOptions]="{ exact: true }"
				>
					<span class="user-tab__icon" aria-hidden="true">
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
						d="M6 2H2.66667C2.29848 2 2 2.29848 2 2.66667V7.33333C2 7.70152 2.29848 8 2.66667 8H6C6.36819 8 6.66667 7.70152 6.66667 7.33333V2.66667C6.66667 2.29848 6.36819 2 6 2Z"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						/>
						<path
						d="M13.3333 2H10C9.63181 2 9.33333 2.29848 9.33333 2.66667V4.66667C9.33333 5.03486 9.63181 5.33333 10 5.33333H13.3333C13.7015 5.33333 14 5.03486 14 4.66667V2.66667C14 2.29848 13.7015 2 13.3333 2Z"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						/>
						<path
						d="M13.3333 8H10C9.63181 8 9.33333 8.29848 9.33333 8.66667V13.3333C9.33333 13.7015 9.63181 14 10 14H13.3333C13.7015 14 14 13.7015 14 13.3333V8.66667C14 8.29848 13.7015 8 13.3333 8Z"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						/>
						<path
						d="M6 10.6667H2.66667C2.29848 10.6667 2 10.9651 2 11.3333V13.3333C2 13.7015 2.29848 14 2.66667 14H6C6.36819 14 6.66667 13.7015 6.66667 13.3333V11.3333C6.66667 10.9651 6.36819 10.6667 6 10.6667Z"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						/>
					</svg>
					</span>
					Overview
				</a>
				<a class="user-tab" routerLink="/user/assessments" routerLinkActive="user-tab--active">
					<span class="user-tab__icon" aria-hidden="true">
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
						d="M9.33073 1.33594H3.9974C3.64377 1.33594 3.30464 1.47642 3.05459 1.72646C2.80454 1.97651 2.66406 2.31565 2.66406 2.66927V13.3359C2.66406 13.6896 2.80454 14.0287 3.05459 14.2787C3.30464 14.5288 3.64377 14.6693 3.9974 14.6693H11.9974C12.351 14.6693 12.6902 14.5288 12.9402 14.2787C13.1903 14.0287 13.3307 13.6896 13.3307 13.3359V5.33594M9.33073 1.33594C9.54176 1.3356 9.75078 1.37701 9.94575 1.45779C10.1407 1.53856 10.3178 1.65711 10.4667 1.80661L12.8587 4.19861C13.0086 4.34761 13.1275 4.52484 13.2085 4.72005C13.2895 4.91526 13.3311 5.12459 13.3307 5.33594M9.33073 1.33594V4.66927C9.33073 4.84608 9.40097 5.01565 9.52599 5.14068C9.65102 5.2657 9.82058 5.33594 9.9974 5.33594L13.3307 5.33594M6.66406 6.00261H5.33073M10.6641 8.66927H5.33073M10.6641 11.3359H5.33073"
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						/>
					</svg>
					</span>
					Assessments
				</a>
				</div> -->

				@if (authenticationService.hasPermissions(["CAN_CREATE_Vendor_Management"])) {
					<a class="user-register-btn" routerLink="/user/vendors/new">
						<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 48 48">
							<path d="M0 0h48v48H0z" fill="none" />
							<path fill="currentColor" fill-rule="evenodd" d="M6.331 5.3C7.551 5.14 9.373 5 12 5s4.449.14 5.669.3c.662.086 1.147.548 1.2 1.419C18.941 7.903 19 9.605 19 12s-.059 4.097-.13 5.281c-.054.87-.54 1.333-1.201 1.42c-1.22.159-3.042.299-5.669.299s-4.449-.14-5.669-.3c-.662-.086-1.147-.548-1.2-1.419C5.059 16.097 5 14.395 5 12s.059-4.097.13-5.281c.054-.87.54-1.333 1.201-1.42M12 1c-2.765 0-4.763.147-6.186.333c-2.762.36-4.52 2.567-4.676 5.143C1.06 7.756 1 9.542 1 12s.06 4.243.138 5.524c.157 2.576 1.914 4.783 4.676 5.143C7.237 22.853 9.234 23 12 23s4.763-.147 6.187-.333c2.761-.36 4.518-2.567 4.675-5.143c.078-1.28.138-3.066.138-5.524s-.06-4.243-.138-5.524c-.157-2.576-1.914-4.783-4.675-5.143C16.763 1.147 14.764 1 12 1m0 24c-2.765 0-4.763.147-6.186.333c-2.762.36-4.52 2.567-4.676 5.143C1.06 31.756 1 33.542 1 36s.06 4.243.138 5.524c.157 2.576 1.914 4.783 4.676 5.143C7.237 46.853 9.234 47 12 47s4.763-.147 6.187-.333c2.761-.36 4.518-2.567 4.675-5.143c.078-1.28.138-3.066.138-5.524s-.06-4.243-.138-5.524c-.157-2.576-1.914-4.783-4.675-5.143C16.763 25.147 14.764 25 12 25m-5.669 4.3c1.22-.16 3.042-.3 5.669-.3s4.449.14 5.669.3c.662.086 1.147.548 1.2 1.419c.072 1.184.131 2.886.131 5.281s-.059 4.097-.13 5.281c-.054.87-.54 1.333-1.201 1.42c-1.22.159-3.042.299-5.669.299s-4.449-.14-5.669-.3c-.662-.086-1.147-.548-1.2-1.419C5.059 40.097 5 38.395 5 36s.059-4.097.13-5.281c.054-.87.54-1.333 1.201-1.42m24.145-4.162C31.756 25.06 33.542 25 36 25s4.243.06 5.524.138c2.576.157 4.783 1.914 5.143 4.676c.186 1.423.333 3.42.333 6.186s-.147 4.763-.333 6.187c-.36 2.761-2.567 4.518-5.143 4.675c-1.28.078-3.066.138-5.524.138s-4.243-.06-5.524-.138c-2.576-.157-4.783-1.914-5.143-4.676C25.147 40.763 25 38.766 25 36s.147-4.763.333-6.186c.36-2.762 2.567-4.52 5.143-4.676M36 29c-2.395 0-4.097.059-5.281.13c-.87.054-1.333.54-1.42 1.201C29.14 31.551 29 33.373 29 36s.14 4.449.3 5.669c.086.662.548 1.147 1.419 1.2c1.184.072 2.886.131 5.281.131s4.097-.059 5.281-.13c.87-.054 1.333-.54 1.42-1.201c.159-1.22.299-3.042.299-5.669s-.14-4.449-.3-5.669c-.086-.662-.548-1.147-1.419-1.2C40.097 29.059 38.395 29 36 29M34.736 2.56c.36-.037.78-.06 1.264-.06s.904.023 1.264.06c1.327.132 2.09 1.262 2.135 2.466c.03.798.062 1.93.081 3.494c1.563.02 2.696.05 3.494.08c1.204.047 2.334.81 2.467 2.136c.036.36.059.78.059 1.264s-.023.904-.06 1.264c-.132 1.327-1.262 2.09-2.466 2.135c-.798.03-1.93.062-3.494.081c-.02 1.563-.05 2.696-.08 3.494c-.047 1.204-.81 2.334-2.136 2.467c-.36.036-.78.059-1.264.059s-.904-.023-1.264-.06c-1.327-.132-2.09-1.262-2.135-2.466c-.03-.798-.062-1.93-.081-3.494c-1.563-.02-2.696-.05-3.494-.08c-1.204-.047-2.334-.81-2.467-2.136c-.036-.36-.059-.78-.059-1.264s.023-.904.06-1.264c.132-1.327 1.262-2.09 2.466-2.135c.798-.03 1.93-.062 3.494-.081c.02-1.563.05-2.696.08-3.494c.047-1.204.81-2.334 2.136-2.467" clip-rule="evenodd" />
						</svg>
						<p>
							New Vendor Application
						</p>
					</a>
				}
		       </div>

		      <router-outlet></router-outlet>
		    </div>
		  </div>
</div>
